'use client';

import { ReactNode } from 'react';

import { SearchCardTabArrivalOrder } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/_components/tabs/arrival-order/search-card-tab-arrival-order.component';
import { SearchCardTabStandalone } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/_components/tabs/standalone/search-card-tab-standalone.component';
import { SearchCardClinicTabScheduled } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/clinic/_components/tabs/scheduled/search-card-clinic-tab-scheduled.component';
import { SearchCardClinicTabFlex } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/clinic/_components/tabs/flex/search-card-clinic-tab-flex.component';
import { SearchCardClinicTabWhatsapp } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/clinic/_components/tabs/whatsapp/search-card-clinic-tab-whatsapp.component';
import { TabsType } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-schedule-tab.hook';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

const TAB_CONTENT_BY_KEY: Record<TabsType, (schedule: SearchPartnerData) => ReactNode> = {
  [TabsType.SCHEDULED]: (schedule) => <SearchCardClinicTabScheduled schedule={schedule} />,
  [TabsType.ARRIVAL_ORDER]: (schedule) => <SearchCardTabArrivalOrder schedule={schedule} />,
  [TabsType.LABORATORIAL]: (schedule) => (
    <SearchCardTabArrivalOrder schedule={schedule} scheduleType={ScheduleType.LABORATORIAL} />
  ),
  [TabsType.FLEX]: (schedule) => <SearchCardClinicTabFlex schedule={schedule} />,
  [TabsType.WHATSAPP]: (schedule) => <SearchCardClinicTabWhatsapp schedule={schedule} />,
  [TabsType.STANDALONE]: (schedule) => <SearchCardTabStandalone schedule={schedule} />,
};

interface ScheduleTabContentProps {
  tabKey: TabsType;
  schedule: SearchPartnerData;
}

export function ScheduleTabContent({ tabKey, schedule }: ScheduleTabContentProps) {
  return TAB_CONTENT_BY_KEY[tabKey]?.(schedule) ?? null;
}
